import { render } from "./PatientExamNewOffcanvas.vue?vue&type=template&id=dc88479c&scoped=true"
import script from "./PatientExamNewOffcanvas.vue?vue&type=script&lang=js"
export * from "./PatientExamNewOffcanvas.vue?vue&type=script&lang=js"

import "./PatientExamNewOffcanvas.vue?vue&type=style&index=0&id=dc88479c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc88479c"]])

export default __exports__